import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';
import {
  mapHeaderFromApiModel,
  mapHeaderToApiModel,
} from './dataMapper/headerDataMapper';

export default (collectionPath, entityId, { headerImageData }) =>
  axios
    .post(getUrl.apiV2(`${collectionPath}/${entityId}/items`), {
      section: 'headers',
      data: [mapHeaderToApiModel(headerImageData)],
    })
    .catch(generateApiError())
    .then(response => mapHeaderFromApiModel(response.data));
